export function formatZipCode(value) {
    if (!value) return value;
    const zipCode = value.replace(/[^\d]/g, '');
    return zipCode.slice(0, 5);
  }
  